import { validateBridgeResponse } from "./bridgeValidator";

import type { NativeBridge } from "./bridge";
import type { BridgeEvents } from "./bridgeEvents";

declare global {
  interface Window {
    flutter_inappwebview?: {
      callHandler: (handlerName: string, ...args: unknown[]) => Promise<unknown>;
    };
  }
}

export class FlutterBridge implements NativeBridge {
  private listeners = new Map<string, EventListener>();

  async call<K extends keyof BridgeEvents>(
    event: K,
    payload?: BridgeEvents[K]["payload"]
  ): Promise<BridgeEvents[K]["response"]> {
    if (!window.flutter_inappwebview) {
      throw new Error("Flutter WebView 없음");
    }
    const result = await window.flutter_inappwebview.callHandler("raidio", event, payload);

    return validateBridgeResponse<BridgeEvents[K]["response"]>(result);
  }

  on<K extends keyof BridgeEvents>(event: K, callback: (data: BridgeEvents[K]["response"]) => void): void {
    const eventName = `raidio:${event}`;

    const listener = (e: Event) => {
      const customEvent = e as CustomEvent;

      callback(customEvent.detail);
    };
    this.listeners.set(eventName, listener);

    window.addEventListener(eventName, listener);
  }
  off<K extends keyof BridgeEvents>(event: K): void {
    const eventName = `raidio:${event}`;

    const listener = this.listeners.get(eventName);

    if (!listener) return;

    window.removeEventListener(eventName, listener);

    this.listeners.delete(eventName);
  }
}
